import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYROLL_EMPLOYEE_DEDUCTIONS_REQUEST =
  "GET_PAYROLL_EMPLOYEE_DEDUCTIONS_REQUEST";
export const GET_PAYROLL_EMPLOYEE_DEDUCTIONS_SUCCESS =
  "GET_PAYROLL_EMPLOYEE_DEDUCTIONS_SUCCESS";
export const GET_PAYROLL_EMPLOYEE_DEDUCTIONS_ERROR =
  "GET_PAYROLL_EMPLOYEE_DEDUCTIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const getPayrollEmployeeDeductionsRequest = (
  payload = {},
  callback
) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTIONS_REQUEST,
  payload,
  callback,
});

export const getPayrollEmployeeDeductionsSuccess = (data) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTIONS_SUCCESS,
  payload: data,
});

export const getPayrollEmployeeDeductionsError = (error) => ({
  type: GET_PAYROLL_EMPLOYEE_DEDUCTIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getPayrollEmployeeDeductionsServiceRequest = async ({
  payrollId,
  employeeId,
  ...params
}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(
    `/payrolls/${payrollId}/employees/${employeeId}/deductions`,
    options
  );
};
